<app-payroll-run-selection
  title="Loonjournaal voor rapportage"
  actionLabel="Exporteren"
  [showActionColumn]="false"
  [initialOpdrachtgeverId]="initialOpdrachtgeverId"
  [initialInstellingId]="initialInstellingId"
  (action)="onExport($event)"
/>
